module.exports = __webpack_public_path__ + "img/24_58.28786e7a.png";